import React from 'react';
import { withTheme } from 'styled-components';

const ShowSettingsDropdownIcon = ({ width, height, theme }) => {
  return (
    <svg
      data-ignore-click-outside="dropdown"
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        data-ignore-click-outside="dropdown"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7569 5.4376C10.95 4.39063 11.0668 3.70561 11.2261 2.81904C11.3113 2.34431 11.7252 2 12.2076 2H15.9681C16.4637 2 16.8845 2.36296 16.9573 2.85316L17.3503 5.50021C18.3052 5.87855 19.1553 6.40365 19.9195 7.06387L22.7317 6.3093C23.1867 6.18719 23.6653 6.39931 23.8805 6.81847L25.5962 10.1609C25.8268 10.6102 25.6863 11.1609 25.2686 11.4447L23.0157 12.9757C23.0486 13.29 23.0655 13.6091 23.0655 13.9321C23.0655 14.5156 23.0104 15.0862 22.9051 15.6391L24.9566 17.3027C25.349 17.6209 25.4424 18.1817 25.1744 18.6099L23.1945 21.7738C22.9386 22.1827 22.4273 22.3507 21.9787 22.1731L19.4566 21.1746C18.7927 21.6766 18.0576 22.0896 17.2691 22.3959L16.9376 25.1208C16.8766 25.6226 16.4505 26 15.945 26H12.1961C11.7189 26 11.3082 25.6628 11.2153 25.1948L10.658 22.3886C9.91039 22.0962 9.21098 21.7078 8.575 21.2386L6.04361 22.1916C5.59838 22.3592 5.09671 22.1899 4.84401 21.7869L2.8401 18.5905C2.57761 18.1718 2.66031 17.6242 3.03474 17.3016L5.03039 15.5827C4.93192 15.0475 4.88047 14.4958 4.88047 13.9321C4.88047 13.5941 4.89897 13.2604 4.93502 12.932L2.72422 11.4106C2.31005 11.1256 2.17187 10.5774 2.40146 10.1302L3.24417 8.48845L4.11126 6.79922C4.33016 6.37279 4.82085 6.16165 5.281 6.29591L7.99793 7.08864C8.80477 6.38572 9.73707 5.82275 10.7569 5.4376ZM16.7553 16.7228C18.2511 15.2151 18.2524 12.7836 16.7582 11.2744V11.2744C15.2407 9.74162 12.763 9.74522 11.2499 11.2824V11.2824C9.76626 12.7897 9.76752 15.209 11.2528 16.7148V16.7148C12.7652 18.2481 15.2384 18.2517 16.7553 16.7228V16.7228Z"
        stroke={
          theme.themeColors.controlBar.rightPanel.icons.settingsIcon.color
        }
        strokeWidth="1.7"
      />
    </svg>
  );
};

export default withTheme(ShowSettingsDropdownIcon);
